import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import { RegisterContact } from "@/dtos/Contact.dto";

/**
 * Composable for registering a new contact
 */
export function useRegisterContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (contact: RegisterContact) => {
      const result = await Contact.registerContact(contact);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to register contact");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
    },
  });
}
